import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import pick from 'lodash/pick';

import {
  Modal,
  ModalBody,
  ModalFooter,
  Button
} from 'reactstrap';

import ModalHeader from '../reactstrap/ModalHeader';

import { registrationSuccess, loginSuccess, loadProjectSuccess } from '../../actions';
import { currentProject } from '../../api';

import RegistrationForm from './RegistrationForm';
import LoginForm from './LoginForm';

const mapStateToProps = state => ({ ...state.registration });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({registrationSuccess, loginSuccess, loadProjectSuccess}, dispatch);
};



const modalPropKeys = Object.keys(Modal.propTypes);

class SignupModal extends Component {
  
  constructor (props){
    super(props);
    this.onSuccess = this.onSuccess.bind(this);
    this.toggleLogin = this.toggleLogin.bind(this);
    
    this.state = {
      isLogin: props.isLogin === true
    }
  }
  
  onSuccess (user) {
    const { loginSuccess, registrationSuccess, loadProjectSuccess, toggle, onSuccess } = this.props
    const { isLogin } = this.state
    if ( typeof onSuccess === 'function' )
      onSuccess();
    
    const successAction = isLogin ? loginSuccess : registrationSuccess;
    
    successAction({...user, noredirect: true});
    currentProject().then((project) => loadProjectSuccess({...project, noredirect: true}));
    toggle();
  }
  
  toggleLogin (){
    this.setState({isLogin: !this.state.isLogin})
  }
  
  render() {
    const { toggle, tagline, initialValues, ...otherProps } = this.props;
    const { isLogin } = this.state;
    const modalProps = pick(otherProps, modalPropKeys);
    const FormComponent = isLogin ? LoginForm : RegistrationForm;
    
    return (
      <Modal {...modalProps} centered={true}>
        {isLogin ? 
          <ModalHeader toggle={toggle} className="text-center">Please log in</ModalHeader>
          :
          <ModalHeader toggle={toggle} className="text-center">
            Create your account
            <div className="modal-tagline">{tagline || 'to Customize, Analyze, Track and Share'}</div>
          </ModalHeader>
        }
        <ModalBody className="activate-modal">
          
          <FormComponent {...{initialValues, onSuccess:this.onSuccess}} />
          
        </ModalBody>
        <ModalFooter>
          <Button color="link" onClick={this.toggleLogin} block>
            { isLogin ?
              "Don't have an account? Sign up"
              :
              'Already have an account? Sign in'
            }
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(SignupModal);


// WEBPACK FOOTER //
// ./src/components/auth/signupModal.js